var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 9 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#261F56",
    d: "M6.873 2.657h1.46V.113A18.714 18.714 0 0 0 6.206 0C4.1 0 2.658 1.325 2.658 3.759v2.24H.334v2.845h2.324v7.155L5.507 16V8.845h2.23L8.09 6H5.506V4.04c0-.821.222-1.384 1.367-1.384Z"
  })));
};
export default SvgFacebook;